import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { generateSingleUseToken } from '../../../../../_apis_/tokengen';
import { getDetailsStatusEmida } from '../../../../../_apis_/dagpacket-recargasServicios';
import { fCurrency } from '../../../../../utils/formatNumber';

function CardDetalle({ cardFunction, cardTitle }) {
  const [dataEmida, setDataEmida] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getData() {
      setLoading(true);
      try {
        const token = await generateSingleUseToken('locker', 1, 4);
        const res = await cardFunction(token);

        setDataEmida(res.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        console.log(error.response);
        setLoading(false);
      }
    }

    getData();
  }, []);
  return (
    <Box display="flex" justifyContent="center">
      {!loading && (
        <Card sx={{ padding: '15px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
                <Typography variant="subtitle2">{cardTitle}</Typography>
                <Typography variant="h3">{fCurrency(dataEmida?.availableBalance)}</Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px', justifyContent: 'center' }}>
                <Typography>{dataEmida?.legalBusinessname}</Typography>
                <Typography>SiteId: {dataEmida?.siteId}</Typography>
                <Typography>MerchantId: {dataEmida?.merchantId}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Card>
      )}

      {loading && <CircularProgress />}
    </Box>
  );
}

export default CardDetalle;
